import { tridionLabels } from '@/infrastructure/Configuration'
import { componentsService } from '@/infrastructure/Factory'

export default {
  async getLabels ({ commit }) {
    commit('loading')

    const { labels } = await window.labelsService.getLabels()
    global.componentsLabels = { ...tridionLabels, ...labels }

    commit('labelsLoaded', true)
    commit('free')
  },

  sendAnalyticsView () {
    const analyticsVariables = {}
    global.trackingService.appendViewData(analyticsVariables)
    global.trackingService.triggerAnalyticsEvent()
  },

  async getSpaCard ({ commit }) {
    commit('loading')

    const { cards, title } = await componentsService.getSpaCard()

    commit('setSpaCard', { cards, title })
    commit('free')
  },

  async setParamsErrorStatus ({ commit }, data) {
    commit('loading')
    commit('setQueryParamError', data)
    commit('free')
  }
}
